import React, { useState, useEffect } from 'react';
import SelectAutoComplete from 'components/Tvendo/Common/SelectAutoComplete';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import GridContainer from 'components/Grid/GridContainer';
import ClosingOpenModal from './ClosingOpenModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';
import { wsGet } from 'services/WService';
import { useModal } from 'hooks/useModal';
import { Add, Close, OpenInNew, Visibility } from '@material-ui/icons';
import moment from 'moment';
import { Link } from 'react-router-dom';
import RegularButton from 'components/CustomButtons/Button';
import { wsCreate } from 'services/WService';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Zona', accessor: 'zone', width: 130 },
  { Header: 'Día', accessor: 'day', width: 130 },
  { Header: 'Estado', accessor: 'status', width: 120 },
  { Header: 'Efectivo', accessor: 'CashSum', width: 120 },
  { Header: 'Cheques', accessor: 'CheckSum', width: 120 },
  { Header: 'Depósitos', accessor: 'TrsfrSum', width: 120 },
  { Header: 'Creado por', accessor: 'created_by', width: 170 },
  { Header: 'Actualizado por', accessor: 'updated_by', width: 170 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function ClosingList() {
  const [notify, showNotify] = useToasty();
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [loading, setLoading] = useState(false);
  const [closings, setClosings] = useState([]);
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState();
  const [closingOpenModal, setClosingOpenModal] = useModal();
  const [dataLoading, setDataLoading] = useState(false);

  async function listClosings() {
    setClosings([]);
    let query = `?start_date=${startDate}&end_date=${endDate}`;
    if (selectedZone !== undefined) {
      query += `&base_zone_id=${selectedZone.id}`;
    }
    setDataLoading(true);
    setLoading(true);
    let res = await wsGet(`pymt/closing${query}`);
    setLoading(false);
    setDataLoading(false);
    if (res.success) {
      setClosings(res.data);
    }
  }
  async function listZones() {
    setDataLoading(true);
    let res = await wsGet('base/zone');
    setDataLoading(false);
    if (res.success) {
      setZones(res.data);
    }
  }

  async function closeDay(closing) {
    let confirm = window.confirm('Seguro de cerrar el día ' + moment(closing.day).format('DD-MM-YYYY') + '?');
    if(!confirm) return;
    setDataLoading(true);
    setLoading(true);
    let res = await wsCreate(`pymt/closing/${closing.id}/close`);
    setLoading(false);
    setDataLoading(false);
    if (res.success) {
      listClosings();
    }
    window.alert(res.message);
  }

  async function reopenDay(closing) {
    let confirm = window.confirm('Seguro de reabrir el día ' + moment(closing.day).format('DD-MM-YYYY') + '?');
    if(!confirm) return;
    setDataLoading(true);
    setLoading(true);
    let res = await wsCreate(`pymt/closing/${closing.id}/reopen`);
    setLoading(false);
    setDataLoading(false);
    if (res.success) {
      listClosings();
    }
    window.alert(res.message);
  }

  useEffect(() => {
    listClosings();
  }, [startDate, endDate, selectedZone]);

  useEffect(() => {
    listZones();
  }, []);

  return (
    <CardContainer
      // title="Cierre de caja"
      title={(<>Cierre de caja {dataLoading && <LoadingSpinner />}</>)}
      permission={ConstantPermissions.PYMT_CLOSINGS_OPEN}
      icon={<Add />}
      onClick={() => {
        setClosingOpenModal();
      }}
    >
      <Toasty action={notify} />
      <ClosingOpenModal
        model={closingOpenModal}
        setOpen={setClosingOpenModal}
        zones={zones}
        showNotify={showNotify}
        reload={listClosings}
      />
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Fecha inicio"
            type="date"
            required
            disabled={loading}
            value={startDate}
            margin="normal"
            onChange={(e) => {
              setStartDate(e.target.value);
            }}
            InputLabelProps={{ shrink: true }}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Fecha fin"
            type="date"
            required
            disabled={loading}
            value={endDate}
            margin="normal"
            onChange={(e) => {
              setEndDate(e.target.value);
            }}
            InputLabelProps={{ shrink: true }}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <SelectAutoComplete
            label="Zona"
            options={zones}
            selectedOption={selectedZone}
            setSelectedOption={setSelectedZone}
          />
        </GridItem>
      </GridContainer>

      <ReactTable
        columns={columns}
        formatDate="DD-MM-YYYY"
        data={closings.map((closing, index) => {
          return {
            num: (
              <div className="actions-right">
                {index + 1}
                <AllowedGuard permission={ConstantPermissions.PYMT_CLOSINGS_SHOW}>
                  <Link to={`/admin/bancos/operaciones/cierre-de-caja/${closing.id}`}>
                    <RegularButton justIcon round simple color="primary" disabled={loading}>
                      <Visibility />
                    </RegularButton>
                  </Link>
                </AllowedGuard>
                {closing.status === 'O' && (
                  <AllowedGuard permission={ConstantPermissions.PYMT_CLOSINGS_CLOSE}>
                    <RegularButton
                      justIcon
                      round
                      simple
                      color="danger"
                      disabled={loading}
                      onClick={() => closeDay(closing)}
                    >
                      <Close />
                    </RegularButton>
                  </AllowedGuard>
                )}
                {closing.status === 'C' && (
                  <AllowedGuard permission={ConstantPermissions.PYMT_CLOSINGS_REOPEN}>
                    <RegularButton
                      justIcon
                      round
                      simple
                      color="success"
                      disabled={loading}
                      onClick={() => reopenDay(closing)}
                    >
                      <OpenInNew />
                    </RegularButton>
                  </AllowedGuard>
                )}
              </div>
            ),
            zone: closing.zone.description,
            day: closing.day,
            status: closing.status === 'O' ? 'Abierto' : 'Cerrado',
            CashSum: parseFloat(closing.CashSum).toFixed(2),
            CheckSum: parseFloat(closing.CheckSum).toFixed(2),
            TrsfrSum: parseFloat(closing.TrsfrSum).toFixed(2),
            created_by: closing.created_by?.name || '-',
            updated_by: closing.updated_by?.name || '-',
            actions: '',
          };
        })}
      />
    </CardContainer>
  );
}

export default ClosingList;
